export default {
  onUpdate: (): void => window.location.reload(),
};
